/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_custom.js                                                                              */
/**********************************************************************************************************************/
/* Subscriptions Custom */
HafasWebapp.prototype.subscriptions.custom = function (_me) {
  // e.g.
  Hafas.ps.sub('/custom/subsription', Hafas.bind(_me.Controller.Custom.Method, _me));
};